"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.recording.active': 'Registrazione Attiva',
    'conversation.recording.inactive': 'Registrazione Inattiva',
};
